import { render, staticRenderFns } from "./zxshouyi.vue?vue&type=template&id=0724b2b6&scoped=true&"
import script from "./zxshouyi.vue?vue&type=script&lang=js&"
export * from "./zxshouyi.vue?vue&type=script&lang=js&"
import style0 from "./zxshouyi.vue?vue&type=style&index=0&id=0724b2b6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724b2b6",
  null
  
)

export default component.exports